import { render, staticRenderFns } from "./batchApplicationSubmit2.vue?vue&type=template&id=19668fda&scoped=true"
import script from "./batchApplicationSubmit2.vue?vue&type=script&lang=js"
export * from "./batchApplicationSubmit2.vue?vue&type=script&lang=js"
import style0 from "./batchApplicationSubmit2.vue?vue&type=style&index=0&id=19668fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19668fda",
  null
  
)

export default component.exports